/* eslint-disable react/prop-types */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import globals from '../../globals/communityGlobals';

const locale = globals.getArea('userActions');

export default function ConfirmationDialog({ isOpen, confirmationTitle, confirmationDesc, onClose, onConfirm }) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{confirmationTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{confirmationDesc}</DialogContentText>
      </DialogContent>
      <DialogActions id="dialog-actions" className="sidePanel-buttons">
        <div className="sidePanel-BackButton">
          <Button onClick={onClose} variant="contained" color="secondary" className="small-btn">
            {locale.getMsg('no')}
          </Button>
        </div>
        {onConfirm && (
          <div className="sidePanel-saveButton">
            <Button variant="contained" color="primary" onClick={onConfirm} className="small-btn">
              {locale.getMsg('yes')}
            </Button>
          </div>
        )}
      </DialogActions>
    </Dialog>
  );
}
